<template>
  <v-autocomplete
    v-model="VALOR_SELECIONADO"
    :label="label"
    :items="filiais"
    item-value="value"
    item-text="text"
    :outlined="outlined"
    clearable
    v-bind="$attrs"
    multiple
    small-chips
  />
</template>

<script>
import {computed, onMounted, ref, watch} from "vue";
import store from "@/store";
import req from "@/api/drp.js";
import {iniciarRequisicao, logout} from "@/helpers";

export default {
  name: "GruposSeparacaoAutocomplete",
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    modelValue: Array,
    grupos: Array,
    label: {
      type: String,
      default: 'Filiais do grupo de separação',
    },
    outlined: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const VALOR_SELECIONADO = computed({
      get: () => props.modelValue,
      set: valor => emit('update:modelValue', valor || []),
    });

    const filiais = ref([]);

    onMounted(buscarFiliais);
    watch(() => props.grupos.toString(), () => {
      VALOR_SELECIONADO.value = [];
      buscarFiliais();
    })

    function buscarFiliais() {
      if (!props.grupos.length) return;

      const parametros = { grupos: props.grupos };

      store.dispatch('loading/addRequisicao',
        req.buscarFiliaisGrupoSeparacao(iniciarRequisicao(), parametros)
          .then((response) => {
            localStorage.token = response.data.token;
            filiais.value = response.data.filiais.map(item => ({value: item.filial, text: `Filial ${item.filial}`}));
          })
          .catch(logout)
      );
    }

    return {
      VALOR_SELECIONADO,
      filiais,
    };
  }
}
</script>

<style scoped>

</style>
